module.exports = __webpack_public_path__ + "img/Floor002367-img3.5b627a63.jpg";